import React, { Component } from "react";

export default class PPE2 extends Component {
	render() {
		return (
			<>
				<div className="container">
					<div className="row mt-5">
						<div className="col-lg-12">
							<div className="section-title">
								<h2>Information</h2>
								<p>
									<b>❯ Project(s) : </b> Projet Personnel Encadré 2<br/>
									<b>❯ Technologie(s) : </b> Php, SQL, Javascript, Composer<br/>
									<b>❯ Base de données : </b> MySQL<br/>
									<b>❯ Spécialités : </b> SLAM<br/>
									<b>❯ Date : </b> 2019<br/>
								</p>
							</div>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-lg-12">
							<h3 className="text-heading">SLAM (Solutions Logicielles et Applications Métier)</h3>

							<h4 className="mb-20">Project Now Song</h4>

							<p>
								Voir le <a href="/ppe/1#PPE1SLAM">Project Personnel Encadrer 1 partie SLAM</a>.
							</p>
						</div>
					</div>
				</div>

			</>
		);
	}
}